import '../../monitoring/filters/grouped_elements/grouped_elements_filter_view.js.coffee'
Customer.Filters ||= {}

class Customer.Filters.ApeTagsFilterView extends Monitoring.Views.SocialContents.Filters.GroupedElementsFilterView
  template: JST["backbone/templates/customer/filters/ape_tags_selection"]

  selectAll: true
  alias: 'Intelligent Tag'
  className: 'tag-filter'

  initialize: (@options = {}) ->
    @searchQuery = new Monitoring.Models.SearchQuery({}, { use_defaults: false })
    @groups_logic = @getGroupsLogic()
    @possible_elements = @initilizeElements()
    @applied_elements = @initilizeElements()

    @tagsByClientCode = @options.tagsByClientCode
    @terms = @tagsByClientCode

  getGroupsLogic: ->
    'first_group_elements': @searchQuery.get(@withPrefix('primary_tags_logic')),
    'second_group_elements': @searchQuery.get(@withPrefix('secondary_tags_logic')),
    'excluded_group_elements': @searchQuery.get(@withPrefix('excluded_tags_logic'))

  getGroupsElements: ->
    first_group_elements: @withPrefix('primary_tags')
    second_group_elements: @withPrefix('secondary_tags')
    excluded_group_elements: @withPrefix('excluded_tags')

  viewFor: (viewId) =>
    new Monitoring.Views.SocialContents.Filters.TagsFilterGroupView(@optionsFor(viewId))

  titles: ->
    first_group_elements: I18n.t('monitoring.taxonomy.first_group_elements')
    second_group_elements: I18n.t('monitoring.taxonomy.second_group_elements')
    excluded_group_elements: I18n.t('monitoring.taxonomy.excluded_group_elements')

  getValues: ->
    {
      primary_tags: _.pluck(@firstGroupView.appliedElements, 'term'),
      secondary_tags: _.pluck(@secondGroupView.appliedElements, 'term'),
      excluded_tags: _.pluck(@excludedGroupView.appliedElements, 'term'),
      primary_tags_logic: @firstGroupView.logic,
      secondary_tags_logic: @secondGroupView.logic,
      excluded_tags_logic: @excludedGroupView.logic,
    }

  _generateAllElements: (terms)->
    result = []
    result.push({ term: term, description: term.replace(/_/g, ' ')}) for term in terms
    result

  getName: ->
    'tags'

  canFilterOnlyPresent: ->
    false
